import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";

export type TResponse = {
  data: {
    data: {
      class: string;
      condition: string;
      type: string;
    }[];
  };
};

const getLoanApplicationConvenants = async (id: number) => {
  const data = await getData(
    `${ajaxEndpoints.LOAN_APPLICATION_CONVENANTS}?loanApplicationId=${id}`
  );

  return data;
};

export default function useLoanApplicationConvenants(id: number) {
  return useQuery<TResponse>(
    [id, "getLoanApplicationConvenants"],
    getLoanApplicationConvenants,
    {
      refetchOnWindowFocus: false,
    }
  );
}
